import { styled } from '~/styled'

export const StepperStepContainer = styled('div', {
  base: [
    'flex',
    'relative',
    'font-body',
    'font-semibold',
    'text-md',
    'items-center',
    'not-last:after:absolute',
    "not-last:after:content-['']",
    'focus-visible:outline-none'
  ],
  variants: {
    canInteract: {
      true: []
    },
    direction: {
      vertical: [
        'flex-row',
        'not-last:after:h-full',
        'not-last:after:left-3.5',
        'not-last:after:top-1/2',
        'not-last:after:w-1',
        'py-3'
      ],
      horizontal: [
        'flex-col',
        'not-last:after:h-1',
        'not-last:after:left-1/2',
        'not-last:after:top-3.5',
        'not-last:after:w-full',
        'px-2'
      ]
    },
    separator: {
      default: ['not-last:after:bg-grey-200'],
      active: ['not-last:after:bg-primary-800'],
      success: ['not-last:after:bg-success'],
      viewed: ['not-last:after:bg-grey-600']
    },
    status: {
      completed: [],
      active: [],
      default: [],
      viewed: [],
      success: [],
      reviewed: []
    }
  },
  compoundVariants: [
    {
      canInteract: true,
      status: 'completed',
      class: [
        'focus-visible:first:outline-2',
        'focus-visible:first:outline-offset-2',
        'focus-visible:first:outline-primary-800',
        'focus-visible:first:outline-solid',
        'hover:first:bg-primary-900',
        'hover:first:text-white!',
        'hover:last:text-primary-900'
      ]
    },
    {
      canInteract: true,
      status: 'active',
      class: [
        'focus-visible:first:outline-2',
        'focus-visible:first:outline-offset-2',
        'focus-visible:first:outline-primary-800',
        'focus-visible:first:outline-solid',
        'hover:first:border-grey-800',
        'hover:first:text-grey-1000',
        'hover:last:text-grey-1000'
      ]
    },
    {
      canInteract: true,
      status: 'viewed',
      class: [
        'focus-visible:first:outline-2!',
        'focus-visible:first:outline-offset-2!',
        'focus-visible:first:outline-primary-800!',
        'focus-visible:first:outline-solid!',
        'hover:first:border-grey-800',
        'hover:first:text-grey-1000',
        'hover:last:text-grey-1000'
      ]
    },
    {
      canInteract: true,
      status: 'reviewed',
      class: [
        'focus-visible:first:outline-2!',
        'focus-visible:first:outline-offset-2!',
        'focus-visible:first:outline-primary-800!',
        'focus-visible:first:outline-solid!'
      ]
    }
  ]
})
